import React from "react";
import type { FunctionComponent } from "react";

const BalanceStatusErrorIcon: FunctionComponent = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#C1123C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4999 5L13.0628 14.186H10.9713L10.5342 5H13.4999ZM13.1057 18.5722C12.8429 18.8574 12.4771 19 12.0086 19C11.5286 19 11.1571 18.8605 10.8943 18.5816C10.6314 18.3027 10.5 17.9093 10.5 17.4016C10.5 16.8751 10.6286 16.4771 10.8857 16.2075C11.1429 15.938 11.5171 15.8032 12.0086 15.8032C12.4829 15.8032 12.85 15.9411 13.11 16.2169C13.37 16.4927 13.5 16.8876 13.5 17.4016C13.5 17.8968 13.3686 18.287 13.1057 18.5722Z"
        fill="white"
      />
    </svg>
  );
};

export default BalanceStatusErrorIcon;
